module.exports = __webpack_public_path__ + "images/emoji/eyeglasses.b111a8e4a8c1ce5e8375.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/eyeglasses.png
// module id = zYJR
// module chunks = 2